import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const NoteIcon = ({ title = 'Note', ...props }: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox="0 0 64 64" {...props}>
    <defs>
      <rect id="path-1" x="0" y="5" width="35" height="37" rx="3" />
      <mask
        id="mask-2"
        maskContentUnits="userSpaceOnUse"
        maskUnits="objectBoundingBox"
        x="0"
        y="0"
        width="35"
        height="37"
        fill="white"
      >
        <use xlinkHref="#path-1" />
      </mask>
      <rect id="path-3" x="0" y="5" width="35" height="37" rx="3" />
      <mask
        id="mask-4"
        maskContentUnits="userSpaceOnUse"
        maskUnits="objectBoundingBox"
        x="0"
        y="0"
        width="35"
        height="37"
        fill="white"
      >
        <use xlinkHref="#path-3" />
      </mask>
    </defs>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g stroke="currentColor">
        <g transform="translate(15.000000, 11.000000)">
          <use id="Rectangle-7" mask="url(#mask-2)" strokeWidth="2" xlinkHref="#path-1" />
          <use id="Rectangle-7" mask="url(#mask-4)" strokeWidth="2" xlinkHref="#path-3" />
          <path d="M6.5,17.5 L29.5,17.5" strokeLinecap="round" />
          <path d="M6.5,21.5 L29.5,21.5" strokeLinecap="round" />
          <path d="M6.5,30.5 L29.5,30.5" strokeLinecap="round" />
          <path d="M7.5,0.5 L7.5,9.5" strokeLinecap="round" />
          <path d="M11.5,0.5 L11.5,9.5" strokeLinecap="round" />
          <path d="M15.5,0.5 L15.5,9.5" strokeLinecap="round" />
          <path d="M19.5,0.5 L19.5,9.5" strokeLinecap="round" />
          <path d="M23.5,0.5 L23.5,9.5" strokeLinecap="round" />
          <path d="M27.5,0.5 L27.5,9.5" strokeLinecap="round" />
          <path d="M6.5,26.5 L24.5,26.5" strokeLinecap="round" />
        </g>
      </g>
    </g>
  </CreateIconComponent>
);

export default NoteIcon;
